<template>
    <div class="content">
        <!-- <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">安全巡查隐患整改</h3> -->
        <div  class="pageHeader">
            <el-tabs v-model="activeName" @tab-click="handleTabClick">
                <el-tab-pane label="安全巡查隐患整改" name="1">
                </el-tab-pane>
                <el-tab-pane label="整改完成申请" name="2">
                </el-tab-pane>
            </el-tabs>
        </div>
        <div v-if="activeName == '1'">
            <HazardRectificationTab1 />
        </div>
        <div v-if="activeName == '2'">
            <HazardRectificationTab2 />
        </div>
    </div>
</template>

<script>

import HazardRectificationTab1 from "./components/hazardRectificationTab1";
import HazardRectificationTab2 from "./components/hazardRectificationTab2";
export default {
    name: 'equipmentInto',
    data() {
        return {
            activeName: '1',
        };
    },
    components: {
        HazardRectificationTab1,
        HazardRectificationTab2
    },
    created() {
    },
    mounted() {
    },
    methods: {
        handleTabClick(val) {
        },
    },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
    width: var(--width);
}
.pageHeader {
    padding-bottom: 5px;
}
</style>